<template>
    <div class="uf-toolbar">
        <div class="uf-search">
            <i class="fal fa-search uf-search__icon"></i>
            <input
                type="text"
                v-model="filterSearch"
                :placeholder="$t('admin.search_by_name')"
                class="uf-search__input"
                @keydown.enter="onFilterChange(filterSearch)"
            />
        </div>
        <router-link to="/company/user/create" class="uf-btn-create">
            <i class="fal fa-plus"></i>
            <span>{{ $t('companies.user.create_one') }}</span>
        </router-link>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'UsersFilters',
  components: {},
  data() {
    return {
      filterSearch: '',
      filters: {}
    }
  },
  computed: {
    ...mapState('company', {
      config: (state) => state.usersConfig
    })
  },
  methods: {
    ...mapActions('company', ['getUsers']),
    onFilterChange(currentFilter) {
      this.config.page = 1
      this.filters.name = currentFilter
      this.config.filters = this.filters
      this.$emit('on-filter-change')
    }
  }
}
</script>

<style scoped>
.uf-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
}

.uf-search {
    position: relative;
    flex: 1;
    min-width: 0;
}

.uf-search__icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 0.8rem;
    pointer-events: none;
}

.uf-search__input {
    width: 100%;
    box-sizing: border-box;
    padding: 9px 12px 9px 34px;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.84rem;
    color: #0f172a;
    background: #f8fafc;
    outline: none;
    transition: all 0.2s;
}

.uf-search__input::placeholder {
    color: #94a3b8;
}

.uf-search__input:hover {
    border-color: #cbd5e1;
}

.uf-search__input:focus {
    border-color: #0891B2;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
}

.uf-btn-create {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 20px;
    background: #0891B2;
    color: #fff !important;
    font-size: 0.85rem;
    font-weight: 600;
    border-radius: 10px;
    text-decoration: none !important;
    transition: background 0.2s;
    white-space: nowrap;
}

.uf-btn-create:hover {
    background: #0e7490;
}

.uf-btn-create i {
    color: #fff !important;
    font-size: 0.8rem;
}

@media (max-width: 576px) {
    .uf-toolbar {
        flex-direction: column;
        align-items: stretch;
        padding: 12px 14px;
    }

    .uf-search {
        max-width: 100%;
    }

    .uf-btn-create {
        justify-content: center;
    }
}
</style>
